import React from "react"

import { AppSitesAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { mainSite, sites, errors } from "@signals"


export default function SitesAutocomplete({ ...props }) {

    return <AppSitesAutocomplete
		value={sites.value}
		error={errors.value?.siteID}
		onChange={e => sites.value = e.target.value}
		excludeOptions={[mainSite.value]}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/sites`}
		{...props}
	/>
}